// extracted by mini-css-extract-plugin
export default {"textArea":"TextArea_textArea__RJA6N","scrollable":"TextArea_scrollable__sKvHp","nonScrollable":"TextArea_nonScrollable__zRULT"};